import {
    Dialog,
    DialogContent,
    Button,
    IconButton,
    Typography,
    AppBar,
    Stack,
    Box,
    TextField,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Checkbox,
    Tooltip,
    Autocomplete,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Loader } from "../../../Helpers/Helpers";
import { useEffect, useRef, useState } from "react";
import { useFormikContext } from "formik";
import { useOutletContext } from "react-router-dom";
import { TableVirtuoso } from "react-virtuoso";

const ManagementDialog = ({ open, onClose, managementOptions }) => {

    const { values, setFieldValue } = useFormikContext();
    const outletContext = useOutletContext();
    const { reportConfiguration } = outletContext;

    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [localSelectedRows, setLocalSelectedRows] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [tempMgmtGroup, setTempMgmtGroup] = useState(
        values.selectedManagementGroups
    );
    const getRowKey = (row) => `${row.id}_${row.profitCenterID ?? "NA"}`;

    // const selectedCount = localSelectedRows.filter(id =>
    //     tableData.some(row => row.id === id)
    // ).length;
    const selectedCount = localSelectedRows.filter(key =>
        tableData.some(row => getRowKey(row) === key)
    ).length;

    const totalCount = tableData.length;


    useEffect(() => {
        if (!open) return;

        const corpList = reportConfiguration?.corpList || [];

        const selectedMgmt = tempMgmtGroup;

        let filteredData = corpList;

        if (selectedMgmt && selectedMgmt !== "All") {
            filteredData = corpList.filter(corp =>
                [corp.propertyType, corp.service, corp.brand, corp.pms]
                    .includes(selectedMgmt)
            );
        }

        if (searchTerm) {
            filteredData = filteredData.filter(item =>
                Object.entries(item).some(([key, val]) =>
                    key !== "id" &&
                    String(val).toLowerCase().includes(searchTerm.toLowerCase())
                )
            );
        }

        setTableData(filteredData);
    }, [tempMgmtGroup, open, searchTerm]);

    useEffect(() => {
        if (open) {
            // const selectedIds =
            //     values.corporationDetails?.map(row => row.id) || [];
            const selectedIds =
                values.corporationDetails?.map(row => getRowKey(row)) || [];

            setTempMgmtGroup(values.selectedManagementGroups);

            setLocalSelectedRows(selectedIds);
        }
    }, [open]);





    const columns = [
        { name: "Corporation Name/DBA Name", dataKey: "corporationName", width: "120px" },
        { name: "Legal Name", dataKey: "legalName", width: "120px" },
        { name: "Property Type", dataKey: "propertyType", width: "110px" },
        { name: "Service", dataKey: "service", width: "110px" },
        { name: "Brand", dataKey: "brand", width: "65px" },
        { name: "PMS", dataKey: "pms", width: "80px" },
    ];


    const handleSelectAll = (checked) => {
        // const updated = checked
        //     ? tableData.map(row => row.id)
        //     : [];
        const updated = checked
            ? tableData.map(row => getRowKey(row))
            : [];

        setLocalSelectedRows(updated);
    };

    // const handleCheckboxChange = (checked, row) => {
    //     let updated;

    //     if (checked) {
    //         updated = [...localSelectedRows, row.id];
    //     } else {
    //         updated = localSelectedRows.filter(id => id !== row.id);
    //     }

    //     setLocalSelectedRows(updated);
    // };

    const handleCheckboxChange = (checked, row) => {
        const rowKey = getRowKey(row);

        let updated;

        if (checked) {
            updated = [...localSelectedRows, rowKey];
        } else {
            updated = localSelectedRows.filter(id => id !== rowKey);
        }

        setLocalSelectedRows(updated);
    };

    const TableComponents = {
        Table: (props) => (
            <Table
                {...props}
                style={{
                    borderCollapse: "separate",
                    tableLayout: "fixed",
                }}
            />
        ),
        TableHead,
        TableRow,
        TableBody,
    };

    const fixedHeaderContent = () => (
        <TableRow sx={{ bgcolor: "#d7d7d7" }}>
            <TableCell
                width="40px"
                sx={{
                    padding: "1px",
                    borderRight: "1px solid white",
                    minWidth: "30px",
                    maxWidth: "30px",
                }}
            >

                <Checkbox
                    size="small"
                    color="grey"
                    disableRipple
                    checked={
                        tableData.length > 0 &&
                        localSelectedRows.filter(id =>
                            // tableData.some(row => row.id === id)
                            tableData.some(row => getRowKey(row) === id)
                        ).length === tableData.length
                    }
                    indeterminate={
                        localSelectedRows.filter(id =>
                            // tableData.some(row => row.id === id)
                            tableData.some(row => getRowKey(row) === id)
                        ).length > 0 &&
                        localSelectedRows.filter(id =>
                            // tableData.some(row => row.id === id)
                            tableData.some(row => getRowKey(row) === id)
                        ).length < tableData.length
                    }
                    onChange={(e) => handleSelectAll(e.target.checked)}
                />
            </TableCell>
            {columns.map((column, index) => (
                <TableCell
                    key={index}
                    width={column.width}
                    sx={{
                        borderRight: "1px solid white",
                        padding: 1,
                        fontSize: "13px",
                        fontWeight: 500,

                        maxWidth: column.width,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                >
                    {column.name === "pms" ? "PMS" : column.name}
                </TableCell>
            ))}
        </TableRow>
    );

    const itemContent = (index) => {
        const row = tableData[index];
        if (!row) return null;

        return (
            <>
                <TableCell sx={{ padding: "1px", borderRight: "1px solid #f2f2f2" }}>
                    <Checkbox
                        size="small"
                        color="grey"
                        disableRipple
                        // checked={localSelectedRows.includes(row.id)}
                        checked={localSelectedRows.includes(getRowKey(row))}
                        onChange={(e) =>
                            handleCheckboxChange(e.target.checked, row)
                        }
                    />
                </TableCell>

                {columns.slice(0, 7).map((column, colIndex) => (
                    <TableCell key={colIndex}>
                        <span title={row[column.dataKey] || "-"}>
                            {row[column.dataKey] || "-"}
                        </span>
                    </TableCell>
                ))}
            </>
        );
    };

    const handleApply = () => {
        const allCorporations = reportConfiguration?.corpList || [];

        // const updatedCorporations = allCorporations.filter(corp =>
        //     localSelectedRows.includes(corp.id)
        // );
        const updatedCorporations = allCorporations.filter(corp =>
            localSelectedRows.includes(getRowKey(corp))
        );
        
        if (updatedCorporations.length <= 1) {
            alert("Combined/Consolidated income statement can't generated for the single corporation, Please select more than one");
            return;
        }

        setFieldValue("corporationDetails", updatedCorporations);

        setFieldValue("selectedCrpCount", {
            selected: localSelectedRows.length,
            total: tableData.length
        });
        setFieldValue("selectedManagementGroups", tempMgmtGroup);
        onClose();
    };

    // console.log("tableDatatableData", tableData)
    return (
        <Dialog open={open} fullScreen>
            <AppBar
                sx={{ position: "relative", bgcolor: "#d7d7d7", height: 45 }}
                elevation={0}
            >
                <Box sx={{ height: 45, alignContent: "center", padding: "0 15px" }}>
                    <Stack
                        direction={"row"}
                        alignItems={"center"}
                        justifyContent={"space-between"}
                    >
                        <Stack direction={"row"}>
                            <IconButton
                                size="small"
                                edge="start"
                                color="inherit"
                                onClick={onClose}
                                aria-label="close"
                                style={{ backgroundColor: "#686868" }}
                                disableRipple
                            >
                                <CloseIcon sx={{ fontSize: "15px" }} />
                            </IconButton>
                            <Typography
                                sx={{
                                    ml: 2,
                                    flexGrow: 10,
                                    color: "#1f1f1f",
                                }}
                                component="div"
                                fontWeight={600}
                                fontSize={"15px"}
                            >
                                Corporation Selection
                            </Typography>
                        </Stack>
                        <Stack direction={"row"} gap={3}>
                            <Button
                                variant="contained"
                                size="small"
                                disableElevation
                                disableRipple
                                sx={{
                                    px: 4,
                                    textTransform: "none",
                                    backgroundColor: "#b5dcf2",
                                    color: "#000",
                                    fontWeight: 400,
                                }}
                                onClick={handleApply}
                            >
                                Apply
                            </Button>
                        </Stack>
                    </Stack>
                </Box>
            </AppBar>
            <DialogContent
                sx={{
                    padding: 1,
                }}
            >
                <Stack gap={2} height={"100%"} direction={"column"}>

                    <Stack direction={"row"} gap={2}>
                        <Autocomplete
                            // fullWidth
                            sx={{ minWidth: 250, maxWidth: 250 }}
                            options={managementOptions}
                            size="small"
                            disableClearable
                            value={
                                managementOptions.find(
                                    (opt) => opt.value === tempMgmtGroup
                                ) || null
                            }
                            onChange={(event, newValue) => {
                                if (newValue?.disabled) return;
                                setSearchTerm("")

                                const selectedValue = newValue?.value || "";

                                setTempMgmtGroup(selectedValue);

                                const corpList = reportConfiguration?.corpList || [];

                                let filtered = corpList;

                                if (selectedValue && selectedValue !== "All") {
                                    filtered = corpList.filter(corp =>
                                        [corp.propertyType, corp.service, corp.brand, corp.pms]
                                            .includes(selectedValue)
                                    );
                                }

                                const newIds = filtered.map(row => getRowKey(row));


                                setTableData(filtered);
                                setLocalSelectedRows(newIds);
                            }}
                            getOptionLabel={(option) => option.label}
                            isOptionEqualToValue={(option, value) => option.value === value.value}
                            getOptionDisabled={(option) => option.disabled}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="filled"
                                    label="Management Group"
                                // placeholder="-Select-"
                                />
                            )}
                        />

                        <TextField
                            // fullWidth
                            size="small"
                            variant="filled"
                            label="Corporations"
                            value={
                                totalCount !== 0 && selectedCount === totalCount
                                    ? "All Corporation(s) selected"
                                    : `${selectedCount || 0} Corporation(s) selected`
                            }
                            InputProps={{
                                readOnly: true
                            }}
                            sx={{
                                minWidth: 250,
                                maxWidth: 250,
                                cursor: "pointer",
                                "& .MuiInputBase-input": {
                                    cursor: "pointer"
                                }
                            }}
                        />
                        <TextField
                            size='small'
                            label='Search'
                            variant="filled"
                            sx={{
                                minWidth: 350,
                            }}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />

                    </Stack>

                    <Box
                        height={"100%"}
                        border={"1px solid #d7d7d7"}
                    // overflow={"auto"}
                    >
                        <TableVirtuoso
                            // style={{ height: "570px" }}
                            data={tableData}
                            components={TableComponents}
                            fixedHeaderContent={fixedHeaderContent}
                            itemContent={itemContent}
                        />
                    </Box>



                </Stack>
            </DialogContent>
            {loading && <Loader loading={loading} />}
        </Dialog>
    )
};

export default ManagementDialog;